import Vue from 'vue'

class MeterDeviceEnergyPriceRepository {
    search(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/meter-device-energy-price/search',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    create(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/meter-device-energy-price/create',
                method: 'post',
                data
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/meter-device-energy-price/update/' + id,
                method: 'post',
                data
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/meter-device-energy-price/delete/' + id,
                method: 'delete',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }
}

export default new MeterDeviceEnergyPriceRepository()
